import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userFormData: {},
  associationResponse: {},
  associateId: localStorage.getItem("associateid") || 0,
  getassociate: {},
  token: sessionStorage.getItem("token") || localStorage.getItem("token") || "",
  cart: JSON.parse(sessionStorage.getItem("cart")) || {},
  // cart:{},
};

const signUpSlice = createSlice({
  name: "signup",
  initialState,
  reducers: {
    addUserData: (state, action) => {
      state.userFormData = action.payload.data;
    },
    addAssociationData: (state, action) => {
      state.associationResponse = action.payload;
    },
    setAssociateId: (state, action) => {
      state.associateId = action.payload;
      localStorage.setItem("associateid", state.associateId);
      sessionStorage.setItem("associateid", state.associateId);
    },
    associateData: (state, action) => {
      state.getassociate = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload; // Save the token in the Redux state
      // localStorage.setItem('jwtToken',JSON.stringify(state.token))
      sessionStorage.setItem("token", state.token);
    },
    addItemToCart: (state, action) => {
      if (action.payload.id in state.cart) {
        state.cart = {
          ...state.cart,
          [action.payload.id]: {
            ...state.cart[action.payload.id],
            quantity: state.cart[action.payload.id].quantity + 1,
          },
        };
      } else {
        state.cart = {
          ...state.cart,
          [action.payload.id]: { ...action.payload, quantity: 1 },
        };
      }

      sessionStorage.setItem("cart", JSON.stringify(state.cart));
    },
    removeItemFromCart: (state, action) => {
      delete state.cart[action.payload.id];
      if (Object.keys(state.cart).length === 0) {
        sessionStorage.removeItem("cart");
      } else {
        sessionStorage.setItem("cart", JSON.stringify(state.cart));
      }
    },
    clearCart: (state) => {
      state.cart = {};
      sessionStorage.removeItem("cart");
    },
  },
});

export const {
  addUserData,
  addAssociationData,
  associateData,
  setToken,
  setAssociateId,
  addItemToCart,
  removeItemFromCart,
  clearCart,
} = signUpSlice.actions;
export default signUpSlice.reducer;
